// extracted by mini-css-extract-plugin
module.exports = {"UserInfo":"UserInfo_UserInfo__3pOOa","UserInfo-Column":"UserInfo_UserInfo-Column__19uzS"};